// ABOUTME: Actuator for a FUNCTION on an interval while the tab is visible. For a query that should
// ABOUTME: drive Apollo's own polling, use useVisibilityPolling instead.
import { useLayoutEffect, useRef } from "react"
import { useWhileVisible } from "./useWhileVisible"

/**
 * The caller owns what happens on a tick — a batch chunk sends it through
 * runSerial, so its poll queues behind the other triggers of the same chunk
 * instead of racing them. The lifecycle is useWhileVisible.
 */
export function useVisibleInterval(run: () => void, intervalMs: number, enabled = true): void {
  // Not useEffectEvent: the timer is created inside `start`, a closure handed to
  // useWhileVisible, and an effect event may only be called from an effect of this
  // component. The ref is written in the commit that rendered `run`, synchronously,
  // so no tick can land between that commit and the write.
  const runRef = useRef(run)
  useLayoutEffect(() => {
    runRef.current = run
  })
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null)

  useWhileVisible({
    enabled: enabled && intervalMs > 0,
    restartOn: intervalMs,
    start: () => {
      if (timerRef.current === null) timerRef.current = setInterval(() => runRef.current(), intervalMs)
    },
    stop: () => {
      if (timerRef.current !== null) {
        clearInterval(timerRef.current)
        timerRef.current = null
      }
    },
  })
}
